module.exports = __webpack_public_path__ + "img/ico_option_minus_on.1beecac5.svg";